import { dayjs } from '@2wunder/klarx-tool'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { Radio, Row } from 'antd'
import { RadioChangeEvent } from 'antd/lib/radio'
import Button from 'app/components/UI-Elements/General/Button'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import * as React from 'react'
import { ReactNode } from 'react'
import { useIntl } from 'react-intl'

import { TimeOptions } from './Timeline'

interface Props {
  timeOptions: TimeOptions
  setTimeOptions: (options: TimeOptions) => void
  filters?: ReactNode
}

const Navigation: React.FC<Props> = ({ timeOptions, setTimeOptions, filters }) => {
  const { formatMessage } = useIntl()

  const handleUnitChange = (e: RadioChangeEvent) => {
    handleTimeOptionsChange(dayjs(timeOptions.start), e.target.value)
  }

  const handleOnTodayClick = () => {
    handleTimeOptionsChange(dayjs())
  }

  const handleNext = () => {
    handleTimeOptionsChange(dayjs(timeOptions.end).add(1, timeOptions.unit))
  }

  const handlePrev = () => {
    handleTimeOptionsChange(dayjs(timeOptions.start).add(-1, timeOptions.unit))
  }

  const handleTimeOptionsChange = (selectedDate: Dayjs, unit = timeOptions.unit) => {
    setTimeOptions({
      start: selectedDate.startOf(unit).valueOf(),
      end: selectedDate.endOf(unit).valueOf(),
      unit
    })
  }

  return (
    <Row gutter={[12, 12]}>
      <KCol xs={24} xl={12} xxl={14}>
        <Row gutter={[12, 12]}>
          <KCol>
            <Radio.Group value={timeOptions.unit} buttonStyle="solid" onChange={handleUnitChange}>
              <Radio.Button value="week">{formatMessage({ id: 'week' })}</Radio.Button>
              <Radio.Button value="month">{formatMessage({ id: 'month' })}</Radio.Button>
            </Radio.Group>
          </KCol>
          <KCol span={7}>{filters}</KCol>
        </Row>
      </KCol>
      <KCol xs={24} xl={12} xxl={10}>
        <Row align="middle" justify="space-between">
          <KCol>
            <Radio.Group buttonStyle="solid">
              <Radio.Button onClick={handlePrev} checked={false} value={-1}>
                <LeftOutlined />
              </Radio.Button>
              <Radio.Button onClick={handleNext} checked={false} value={1}>
                <RightOutlined />
              </Radio.Button>
            </Radio.Group>
          </KCol>
          <KCol>
            <Choose>
              <When condition={timeOptions.unit === 'month'}>
                {dayjs(timeOptions.start).format('MMMM YYYY')}
              </When>
              <Otherwise>{dayjs(timeOptions.end).format('[KW] WW YYYY')}</Otherwise>
            </Choose>
          </KCol>
          <KCol>
            <Button type="default" onClick={handleOnTodayClick}>
              {formatMessage({ id: 'today' })}
            </Button>
          </KCol>
        </Row>
      </KCol>
    </Row>
  )
}

export default Navigation
